// Adapted from https://github.com/spring-io/spring-asciidoctor-extensions/blob/main/block-switch/src/main/resources/blockSwitch.js

export const addBlockSwitches = () => {
    document.querySelectorAll('.primary').forEach(function(primary) {
        const switchItem = createSwitchItem(primary, createBlockSwitch(primary));
        switchItem.item.classList.add("selected");
        const title = primary.querySelector('.title')!!;
        title.remove();
    })
    document.querySelectorAll('.secondary').forEach(function(secondary) {
        const primary = findPrimary(secondary);
        if (primary === null) {
            console.error("Found secondary block with no primary sibling");
        }
        else {
            const switchItem = createSwitchItem(secondary, primary.querySelector('.switch')!!);
            switchItem.content.classList.add("hidden");
            primary.append(switchItem.content);
            secondary.remove();
        }
    })
}

function createElementFromHtml(html: string): HTMLElement {
    const template = document.createElement('template');
    template.innerHTML = html;
    return (template.content.firstChild!! as HTMLElement);
}

function createBlockSwitch(primary: Element) {
    var blockSwitch = createElementFromHtml('<div class="switch"></div>');
    primary.prepend(blockSwitch)
    return blockSwitch;
}

function findPrimary(secondary: Element) {
    var candidate = secondary.previousElementSibling;
    while (candidate != null && !candidate.classList.contains('primary')) {
        candidate = candidate.previousElementSibling;
    }
    return candidate;
}

function createSwitchItem(block: Element, blockSwitch: Element) {
    const blockName = block.querySelector('.title')!!.textContent!!;
    const content = block.querySelectorAll('.content').item(0) as HTMLElement;
    const colist = nextSibling(block, '.colist');
    if (colist != null) {
        content.append(colist);
    }
    const item = createElementFromHtml('<div class="switch--item">' + blockName + '</div>');
    item.dataset.blockName = blockName;
    content.dataset.blockName = blockName;
    blockSwitch.append(item);
    return {'item': item, 'content': content};
}

function nextSibling(element: Element, selector: string) {
    var sibling = element.nextElementSibling;
    while (sibling) {
        if (sibling.matches(selector)) {
            return sibling;
        }
        sibling = sibling.nextElementSibling;
    }
}

export const globalSwitch = () => {
    document.querySelectorAll(".switch--item").forEach(function(item) {
        const blockId = blockIdForSwitchItem(item);
        const handler = function (event: Event) {
            const selectedText = (event.target as Element).textContent!!;
            window.localStorage.setItem(blockId, selectedText);
            document.querySelectorAll(".switch--item").forEach(function (switchItem) {
                if (blockIdForSwitchItem(switchItem) === blockId && switchItem.textContent === selectedText) {
                    select(switchItem as HTMLElement);
                }
            })
        };
        item.addEventListener("click", handler);
        if (item.textContent === window.localStorage.getItem(blockId)) {
            select(item as HTMLElement);
        }
    });
}

function select(selected: HTMLElement) {
    selected.parentNode!!.childNodes.forEach(function(child) {
        (child as HTMLElement).classList.remove("selected");
    })
    selected.classList.add("selected");
    selected.parentNode!!.parentNode!!.childNodes.forEach(function(child) {
        if (child instanceof HTMLElement && child.classList.contains("content")) {
            if (selected.dataset.blockName === child.dataset.blockName) {
                child.classList.remove("hidden")
            }
            else {
                child.classList.add("hidden");
            }
        }
    })
}

function blockIdForSwitchItem(item: Element) {
    let idComponents: string[] = [];
    item.parentNode!!.querySelectorAll(".switch--item").forEach(function(switchItem){
        idComponents.push(switchItem.textContent!!.toLowerCase());
    })
    return idComponents.sort().join("-")
}
